var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"question-block d-flex justify-content-center align-items-center",class:_vm.getBlockBackgroundColor(),on:{"click":function($event){return _vm.blockClicked()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }